var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHealthcare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.166 9C17.9609 9 19.416 10.4551 19.416 12.25H20.667C21.7714 12.2502 22.667 13.1455 22.667 14.25V20.25C22.667 21.3545 21.7714 22.2498 20.667 22.25H11.333C10.2286 22.2498 9.33301 21.3545 9.33301 20.25V14.25C9.33301 13.1455 10.2286 12.2502 11.333 12.25H12.583C12.583 10.4552 14.0382 9.00018 15.833 9H16.166ZM16 14.625C15.5858 14.625 15.25 14.9608 15.25 15.375V16.5H14C13.5858 16.5 13.25 16.8358 13.25 17.25C13.25 17.6642 13.5858 18 14 18H15.25V19.125C15.25 19.5392 15.5858 19.875 16 19.875C16.4142 19.875 16.75 19.5392 16.75 19.125V18H18L18.0771 17.9961C18.4551 17.9575 18.75 17.6382 18.75 17.25C18.75 16.8618 18.4551 16.5425 18.0771 16.5039L18 16.5H16.75V15.375C16.75 14.9608 16.4142 14.625 16 14.625ZM15.833 10.5C14.8667 10.5002 14.083 11.2836 14.083 12.25H17.916C17.916 11.2835 17.1325 10.5 16.166 10.5H15.833Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHealthcare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/healthcare.2c617ecff3b5c359fcb8a68f9145db00.svg";